/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated.js';
import { createIndexTransform } from '../../factoriesAny.js';
export var indexTransformDependencies = {
  IndexDependencies,
  createIndexTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIndexTransform.generated.js
// module id = 1381
// module chunks = 2